import { Heading, Stack, Text } from '@metservicedev/met-ui';
import React from 'react';

interface State {
  error: string | null;
}

interface Props {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { error: '' };
  }

  static getDerivedStateFromError(error: any) {
    return { error: error.message };
  }

  componentDidCatch(error: any, info: any) {
    // eslint-disable-next-line no-console
    console.error(error, info?.componentStack);
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) {
      return (
        <Stack align="center">
          <Heading data-testid="error-heading">An error occurred!</Heading>
          <Text data-testid="error-details">{error}</Text>
        </Stack>
      );
    }
    return children;
  }
}
